import { serializable, alias, primitive, object, list } from 'serializr';
import { MarketBasedData } from './marketBased.model';


export class ScopeMonthlyData{

  @serializable
  month?: number;

  @serializable
  value?: number;

  @serializable
  label?: string ;
}

export class ScopeData {

  @serializable
  id?: number;

  @serializable
  unit?: string | null;

  @serializable(alias('fuel_name', primitive()))
  fuelName?: string;

  @serializable(alias('fuel_value', primitive()))
  fuelValue?: number | null;

  @serializable(alias('is_yearly', primitive()))
  isYearly?: boolean = true;

  @serializable(alias('refrigerant_label', primitive()))
  refrigerantLabel?: string | null;

  @serializable(alias('refrigerant_region_spec_id', primitive()))
  refrigerantRegionSpecId?: number | null;

  @serializable(alias('scope_category', primitive()))
  scopeCategory?: string;

  @serializable(alias('scope_field_category', primitive()))
  scopeFieldCategory?: string;

  @serializable(alias('scope_monthly_data', list(object(ScopeMonthlyData))))
  scopeMonthlyData?: ScopeMonthlyData[];

  constructor() {
    if (this?.getPlaceholder) {
      this.getPlaceholder = this.getPlaceholder.bind(this);
    }
  }

  getPlaceholder?(): string {
    let placeholder = '';

    // Special mapping for specific fuel names
    const specialLabels: { [key: string]: string } = {
      'purchased_CO2': 'Other Direct Emissions ',
      'unit': 'kgCO2e',
      // Add other special cases if needed
    };

    if (this?.fuelName) {
      // Check if there's a special label for this fuel name
      if (specialLabels[this.fuelName]) {
        placeholder = specialLabels[this.fuelName];
        placeholder += `(${specialLabels['unit']})`;
        return placeholder.trim();
      } else {
        // Default transformation for other fuel names
        placeholder = this.fuelName?.split('_') // Split the string by underscores
          .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
          .join(' ');
      }
    }
    if (this?.unit) {
      // Append unit with a space if fuelName exists
      placeholder += ` (${this.unit})`;
    }

    // If both fields are undefined or empty, return an empty string
    return placeholder.trim();
  }
  // Un comment after client give confirmation
  // @serializable(alias('electricity_from_rec', object(MarketBasedData)))
  // electricityFromRec?: MarketBasedData;
  
}